var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDesktopOptimised(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 212,
    height: 148,
    viewBox: "0 0 212 148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433",
    transform: "translate(-1277 -951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_1904667_apple_computer_desktop_device_monitor_icon",
    "data-name": "1904667_apple_computer_desktop_device_monitor_icon",
    d: "M121,0H-33a7,7,0,0,0-7,7V109a7,7,0,0,0,7,7H25v26H9a3,3,0,0,0,0,6H79a3,3,0,0,0,0-6H63V116h58a7,7,0,0,0,7-7V7a7,7,0,0,0-7-7ZM-33,6H121a1,1,0,0,1,1,1V93H-34V7A1,1,0,0,1-33,6ZM57,142H31V116H57Zm64-32H-33a1,1,0,0,1-1-1V99H122v10A1,1,0,0,1,121,110Z",
    transform: "translate(1317 951)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    width: 68,
    height: 98,
    transform: "translate(1417 976)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M91,0H37A11,11,0,0,0,26,11V117a11,11,0,0,0,11,11H91a11,11,0,0,0,11-11V11A11,11,0,0,0,91,0ZM32,22.69H96V99.58H32ZM37,6H91a5,5,0,0,1,5,5v5.69H32V11A5,5,0,0,1,37,6ZM91,122H37a5,5,0,0,1-5-5V105.58H96V117A5,5,0,0,1,91,122Z",
    transform: "translate(1387 971)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(1445 1078.91)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M7,15.5A6.5,6.5,0,1,0,13.5,9,6.5,6.5,0,0,0,7,15.5Z",
    transform: "translate(1422.336 996.477)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M14,15.5A6.5,6.5,0,1,0,20.5,9,6.5,6.5,0,0,0,14,15.5Z",
    transform: "translate(1445.666 996.477)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M41.188,27.458a4.333,4.333,0,0,0,.385-6.115,21.665,21.665,0,0,0-32.48-.034,4.333,4.333,0,1,0,6.488,5.744,13,13,0,0,1,19.492.02A4.332,4.332,0,0,0,41.188,27.458Z",
    transform: "translate(1425.683 1013.144)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M13.824,33.514,9.428,41.9,0,41.9l4.4-8.387Zm18.81,0V41.9l-9.448,0V33.514Zm0-16.727v8.387H8.741l4.4-8.387ZM24.247,0a8.388,8.388,0,0,1,8.368,7.813l.019.574H17.446L21.842,0Z",
    transform: "translate(1343.314 979.231)",
    fill: "#999",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDesktopOptimised);
export default __webpack_public_path__ + "static/media/icon-desktop-optimised.1a4fd2f7d76fd70e07db09e32569a078.svg";
export { ForwardRef as ReactComponent };